import { Box, TableCell } from "@mui/material";
import { styled } from "@mui/system";

export const TableCellConstantWidth = styled(TableCell)(() => ({
  minWidth: "230px",
}));

export const TableCellGray = styled(TableCell)(() => ({
  backgroundColor: "lightgray",
}));

export const HeaderBox = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
}));
